<div class="content">
    <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" style="cursor: pointer;margin-bottom: 15px;">
            <div class="card card-style" [routerLink]="['../vendors']" style="border-radius: 0px;padding: 15px;">
                <div class="header text-center">
                    <img src="../../../../assets/images/boy.svg" style="height: 50px;" />
                </div>
                <div class="content text-center" style="padding: 5px;padding-top:0px;margin-top: 15px;">
                    <span style="font-weight: bold;
                                    font-size: 13px;">SPECTACLE VENDORS</span>
                    <p style="font-size: 12px;padding-top:5px">
                        As a Spectacle Vendor manage your spectacle business, create inventories, add specifications for
                        frames and lenses, associate courier vendors for order dispatch, stock management, Spectacle
                        Operator user creation and management, dashboard, reports, and statistics.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>